/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import {Tab, Nav} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../_helpers";
import {AENotification} from "../../../../../_emywork/AENotification";
import {useDispatch, useSelector} from "react-redux";
import {fetchNotifications, readNotification} from "../../../../../app/modules/Auth/_redux/Notifications/actions";
import {actionTypes} from "../../../../../app/modules/Auth/_redux/Notifications/slice";
import {useIntl} from "react-intl";
import {AELink} from "../../../../../_emywork/components/AELink";
import {AEDuration, AEMoment} from "../../../../../_emywork/components/moment";
import moment from "moment";
import {getNotificationsStatistics} from "../../../../../app/pages/Dashboard/_redux/crud";
import {fetchNotificationsStatistics} from "../../../../../app/pages/Dashboard/_redux/actions";
import {AESVG} from "../../../../../_emywork/components/svg";

export function QuickPanel() {
  const [selectedTab, setSelectedTab] = useState("Notifications");
  const setTab = _tabName => {
    setSelectedTab(_tabName);
  };

  const {formatMessage} = useIntl();
  const {notifications} = useSelector(s=>({
    notifications: s.notifications[actionTypes.List].entities || []
  }));
  const dispatch = useDispatch();
  const refreshNotifications = () => {
    dispatch(fetchNotifications())
    dispatch(fetchNotificationsStatistics())
  }
  useEffect(()=>{
    refreshNotifications()
  }, [])

  return (
      <>
        <AENotification event={'NOTIFICATION.CREATE_EMY_PROJECT_INVITE'} />
        <AENotification event={'NOTIFICATION.CREATE_EMY_PROJECT_COMMENT'} />
        <AENotification event={'NOTIFICATION.UPDATE_EMY_PROJECT_STATUS'} />
        <AENotification event={'NOTIFICATION.CREATE_PROPOSAL'} />
        <AENotification event={'NOTIFICATION.UPDATE_PROPOSAL_STATUS'} />
        <AENotification event={'NOTIFICATION.UPDATE_PROPOSAL_PROVIDER_STATUS'} />
        <AENotification event={'NOTIFICATION.CREATE_EMY_PRODUCT_REVIEW'} />
        <AENotification event={'NOTIFICATION.UPDATE_EMY_PRODUCT_STATUS'} />
        <AENotification event={'NOTIFICATION.CREATE_EMY_SERVICE_REVIEW'} />
        <AENotification event={'NOTIFICATION.UPDATE_EMY_SERVICE_STATUS'} />
        <AENotification event={'NOTIFICATION.CREATE_PRIVATE_MESSAGE'} />
        <AENotification event={'NOTIFICATION.CREATE_TEAM_MESSAGE'} />


        <div id="kt_quick_panel" className="offcanvas offcanvas-right pt-5 pb-10">
          <Tab.Container
            defaultActiveKey={selectedTab}
          >
            {/*begin::Header*/}
            <div
              className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
              <Nav
                onSelect={setTab}
                as="ul"
                role="tablist"
                className="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x nav-tabs-primary flex-grow-1 px-10"
              >
                {/*<Nav.Item as="li">*/}
                {/*  <Nav.Link*/}
                {/*      eventKey="AuditLogs"*/}
                {/*      className={`nav-link ${*/}
                {/*          selectedTab === "AuditLogs" ? "active" : ""*/}
                {/*      }`}*/}
                {/*  >*/}
                {/*    Audit Logs*/}
                {/*  </Nav.Link>*/}
                {/*</Nav.Item>*/}
                <Nav.Item className="nav-item" as="li">
                  <Nav.Link
                    eventKey="Notifications"
                    className={`nav-link ${
                      selectedTab === "Notifications" ? "active" : ""
                    }`}
                  >
                    {formatMessage({id: 'NOTIFICATIONS'})}
                  </Nav.Link>
                </Nav.Item>
                {/*<Nav.Item as="li">*/}
                {/*  <Nav.Link*/}
                {/*      eventKey="Settings"*/}
                {/*      className={`nav-link ${*/}
                {/*          selectedTab === "Settings" ? "active" : ""*/}
                {/*      }`}*/}
                {/*  >*/}
                {/*    Settings*/}
                {/*  </Nav.Link>*/}
                {/*</Nav.Item>*/}
              </Nav>

              <div className="offcanvas-close mt-n1 pr-5" style={{position: "absolute", top: "15px", right: "10px"}}>
                <a
                  href="#"
                  className="btn btn-xs btn-icon btn-light btn-hover-primary"
                  id="kt_quick_panel_close"
                >
                  <i className="ki ki-close icon-xs text-muted"/>
                </a>
              </div>
            </div>
            {/*end::Header*/}

            {/*begin::Content*/}
            <div className="offcanvas-content px-10">
              <div className="tab-content">
                <div
                  id="kt_quick_panel_notifications"
                  role="tabpanel"
                  className={`tab-pane fade pt-2 pr-5 mr-n5 scroll ps ${selectedTab === "Notifications" ? "active show" : ""}`}
                >
                  {
                    notifications.map(notification=>(
                      <div
                        key={notification.id}
                        className="navi navi-icon-circle navi-spacer-x-0"
                      >
                        <AELink
                          to={notification.data.url}
                          className="navi-item"
                          onClick={()=>{
                              dispatch(readNotification(notification.id)).then(r=>{
                                refreshNotifications()

                              })
                            }
                          }
                        >
                          <div className="navi-link rounded pt-0">
                            <div className="symbol symbol-30 mr-3">
                              <div className="symbol-label">
                                <AESVG
                                  path={'/General/Notifications1.svg'}
                                  variant={notification.read_at ? '' : 'primary' }
                                />
                                {/*<i className="flaticon-bell text-primary" />*/}
                              </div>
                            </div>
                            <div className="navi-text">
                              <div className={`font-weight-bold ${notification.read_at ? 'text-muted' : ''}`}>
                                {formatMessage({id: notification.data.event || "NOTIFICATION"})}
                              </div>
                              <small className="text-muted">
                                <AEDuration
                                  duration={-moment().diff(moment(notification.created_at), 'seconds')}
                                  unit={'seconds'}
                                  argWithSuffix
                                />
                                {/*<AEDuration duration={}*/}
                                {/*<AEMoment date={notification.created_at} format={'LLLL'}/>*/}
                              </small>
                            </div>
                          </div>
                        </AELink>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
            {/*end::Content*/}
          </Tab.Container>
        </div>
      </>
  );
}
